export const applySlideScaling = () => {
  if (!window.storeeelItems.isMobile) {
    document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide-active').forEach((el) => {
      el.style.transform = 'scale(1)';
      el.style.transition = 'transform 0.5s ease';
    });

    const active = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active');
    if (active) active.style.transform = 'scale(1.00)';

    const prev = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-prev');
    if (prev) prev.style.transform = 'scale(0.55)';

    const next = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-next');
    if (next) next.style.transform = 'scale(0.55)';
  }
};
